import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Constatation, ConstatationDetail } from '@shared/models/constatation';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConstatationService {
  private http: HttpClient = inject(HttpClient);
  public pagination = { pageSize: 25, pageNumber: 1, totalCount: 0 };

  public getAll(params?: {
    stateId?: number;
    date?: string;
    search?: string;
  }): Observable<Constatation[]> {
    return this.http
      .get<any>(`${environment.api.root}/offences`, {
        params: {
          ...params,
          pageSize: this.pagination.pageSize,
          pageNumber: this.pagination.pageNumber,
        },
      })
      .pipe(
        map((response) => {
          this.pagination = {
            pageSize: response.pageSize,
            pageNumber: response.page,
            totalCount: response.totalCount,
          };
          return response?.items || [];
        }),
      );
  }

  public get(
    id: number | string,
    params?: { stateId?: number; date?: string; search?: string },
  ): Observable<ConstatationDetail> {
    return this.http.get<ConstatationDetail>(
      `${environment.api.root}/offences/${id}`,
      { params },
    );
  }

  public validate(
    id: number,
    constatation: Partial<ConstatationDetail>,
    remark?: string,
  ): Observable<void> {
    return this.http.put<void>(
      `${environment.api.root}/offences/${id}/validate`,
      this.mapDataForCorrection(constatation, remark),
    );
  }

  public refuse(
    id: number,
    constatation: Partial<ConstatationDetail>,
    remark?: string,
    refusalReason?: string,
  ): Observable<void> {
    return this.http.put<void>(
      `${environment.api.root}/offences/${id}/refuse`,
      {
        ...this.mapDataForCorrection(constatation, remark),
        refusalReason: refusalReason || null,
      },
    );
  }

  private mapDataForCorrection(
    constatation: Partial<ConstatationDetail>,
    remark?: string,
  ) {
    return {
      offenceIdCorrection: constatation.offenceId,
      offenceTypeCorrection: constatation.offenceType,
      photoTypeCorrection: constatation.photoType,
      plateCorrection: constatation.plate,
      plateCountryCodeCorrection: constatation.plateCountryCode,
      vehicleCategoryCorrection: constatation.vehicleCategory,
      remark,
    };
  }
}
